import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import addOrUpdate from './add-or-update';
import JobLeave from './job-leave-manger';
import { getTableFn, delFn, getTypeFn as _getTypeFn } from 'api/org/position';
export default {
  components: {
    addOrUpdate: addOrUpdate,
    JobLeave: JobLeave
  },
  data: function data() {
    return {
      // 动态展示
      jobVisible: false,
      dataForm: {},
      pageSizes: [100, 50, 20],
      page: {
        list: [],
        currPage: 1,
        limit: 100,
        total: 0
      },
      tableLoading: false,
      isAddOrUpdate: false,
      typeArr: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 200;
    }
  }),
  mounted: function mounted() {
    this.getTypeFn();
  },
  methods: {
    getTypeFn: function getTypeFn() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getTypeFn();
            case 2:
              res = _context.sent;
              if (res && res.code === 1) {
                _this.typeArr = res.data;
                _this.getTableData();
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 职等职级设置
    openEl: function openEl() {
      this.jobVisible = true;
    },
    getTableData: function getTableData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.tableLoading = true;
              _context2.next = 3;
              return getTableFn({
                page: _this2.page.currPage,
                page_size: _this2.page.limit,
                search_name: _this2.dataForm.search_name
              });
            case 3:
              res = _context2.sent;
              _this2.tableLoading = false;
              if (res && res.code === 1) {
                _this2.page.total = res.data.total_count;
                _this2.page.list = res.data.rows;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getJobTitleTypeObj: function getJobTitleTypeObj(type) {
      return this.typeArr.filter(function (v) {
        return Number(v.type_id) === Number(type);
      })[0];
    },
    // 每页条数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.page.limit = val;
      this.getTableData();
    },
    // 切换 页
    currentChangeHandle: function currentChangeHandle(val) {
      this.page.currPage = val;
      this.getTableData();
    },
    addOrUpdate: function addOrUpdate(item) {
      var _this3 = this;
      this.isAddOrUpdate = true;
      this.$nextTick(function () {
        _this3.$refs.addOrUpdate.init(item || null);
      });
    },
    deleteHandle: function deleteHandle(item) {
      var _this4 = this;
      this.$confirm(this.$t('62'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        delFn({
          id: item.id
        }).then(function (res) {
          if (res && res.code === 1) {
            _this4.$message({
              type: 'success',
              message: res.message,
              onClose: function onClose() {
                return _this4.getTableData();
              }
            });
          }
        });
      });
    }
  }
};